module.exports = __webpack_public_path__ + "img/markers.dbd8b5f5.svg";